import { selectFromVisitDto, selectFromVisitPaginatedDto } from '../../models';

export const UnscheduledVisitDetailQuery = selectFromVisitDto()
  .id
  .uuid
  .name
  .phone
  .email
  .load
  .email
  .duration
  .lockedActionUuid
  .instructions
  .eventUuid
  .isCompleted
  .isScheduled
  .tags(tag => tag.uuid.name)
  .customFields
  .routificOrderNumber
  .customerOrderNumber
  .deliveryDate
  .locations(b => b
    .address
    .originalAddress
    .latitude
    .longitude
    .locationStatusId
    .bestMatch
    .active
    .coordinatesSource)
  .timeWindows(b => b.id.startTime.endTime)
  .unscheduledReason(r => r.id.reasonCode)
  .toString();

export const UnscheduledPaginatedVisitsQuery = selectFromVisitPaginatedDto()
  .hasNextPage
  .totalCount
  .edges(b => b.node(UnscheduledVisitDetailQuery))
  .toString();
